import React from 'react';
import Index from './index'

export default class Main extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        const { userid,username,time,template, otherPromptInfo} = this.props;
        String.prototype.replaceAll = function(s1, s2) {
            return this.replace(new RegExp(s1, "gm"), s2);
        }
        let msg = template.replaceAll("\\${user}", `<span class="wf-reject-msg-user"><a href="javaScript:openhrm(${userid})" onClick="javaScript:window.pointerXY(event)">${username}</a></span>`)
        msg = msg.replace("${time}", `<span class="wf-reject-msg-time">${time}</span>`);
        return (
            <div>
                <Index ecId={`${this && this.props && this.props.ecId || ''}_Index@zbzgix`} {...otherPromptInfo} />
                <div className="wf-reject-msg">
                    <span><i className="icon-coms02-Warning-01" /></span>
                    <span dangerouslySetInnerHTML={{__html:msg}}></span>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/topPropmpt/AgentInfo.js